/**
 * @fileoverview GET handler for the "/companies/:company_id/verified_domains/:id" endpoint
 */
import fetch from "@lib/fetch";

import { createGetFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createGetFetcherFunctionWithShadowError";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdVerifiedDomainsId } from "./constants";
import type {
  GetCompaniesCompanyIdVerifiedDomainsIdProps,
  GetCompaniesCompanyIdVerifiedDomainsIdResult,
  GetCompaniesCompanyIdVerifiedDomainsIdResultErrors,
} from "./types";
import { isGetCompaniesCompanyIdVerifiedDomainsIdResult } from "./validators";

export const getCompaniesCompanyIdVerifiedDomainsId = reactQueryFetcherAdapter(
  companiesCompanyIdVerifiedDomainsId,
  createGetFetcherFunctionWithShadowError<GetCompaniesCompanyIdVerifiedDomainsIdResultErrors>()(
    (
      signal: AbortSignal,
      { companyId, id, type }: GetCompaniesCompanyIdVerifiedDomainsIdProps
    ): Promise<GetCompaniesCompanyIdVerifiedDomainsIdResult> => {
      return fetch(
        `/companies/${companyId}/verified_domains/${id}`,
        "GET",
        { type },
        { signal },
        { propagateFetchRequestError: false }
      );
    }
  ),
  isGetCompaniesCompanyIdVerifiedDomainsIdResult
);
